import React, { useEffect, useState } from "react";
import { conf } from "../const";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

export default function Delivery() {
  const [report, setReport] = useState();
  const styles = {
    td: { fontSize: "10pt", border: "1px solid #111", padding: "3px 3px" },
    total: {
      fontSize: "10pt",
      border: "1px solid #111",
      padding: "3px 3px",
    },
  };
  useEffect(() => {
    const cookie = JSON.parse(localStorage.getItem(conf.cookiePrint));
    setReport(cookie.print);
  }, []);
  useEffect(() => {
    if (report) {
      setTimeout(() => window.print(), 500);
    }
  }, [report]);

  return (
    <div
      style={{
        textAlign: "center",
        margin: "auto",
        width: "20.5cm",
      }}
    >
      {report && (
        <>
          <h2 className="bold">{report.headers[0].label}</h2>
          <div className="bold" style={{ marginBottom: "15px" }}>
            {report.headers[1].label}
          </div>
          <TableContainer>
            <Table size="small" sx={{ border: "1px solid #111" }}>
              <TableHead>
                <TableRow>
                  {report.table.cols.map((col, key) => (
                    <TableCell
                      key={key}
                      sx={{
                        ...col.style,
                        ...styles.td,
                      }}
                    >
                      {col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {report.table.rows.map((row, key) => (
                  <TableRow key={key}>
                    <TableCell sx={styles.td} align="center">
                      {row.col_0}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {row.col_1}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {row.col_2}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {row.col_3}
                    </TableCell>
                    <TableCell sx={styles.td} align="center">
                      {row.col_4}
                    </TableCell>
                    <TableCell
                      sx={{ ...{ color: "#f00" }, ...styles.td }}
                      align="center"
                    >
                      {row.col_5.map((r, key) => (
                        <div key={key}>{r}</div>
                      ))}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell
                    sx={styles.total}
                    colSpan={3}
                    className="bold"
                    align="center"
                  >
                    รวม
                  </TableCell>
                  <TableCell className="bold" align="center" sx={styles.total}>
                    {report.table.total.col_3}
                  </TableCell>
                  <TableCell className="bold" align="center" sx={styles.total}>
                    {report.table.total.col_4}
                  </TableCell>
                  <TableCell sx={styles.total} />
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div
            style={{
              textAlign: "left",
              fontSize: "11pt",
              lineHeight: "17pt",
              padding: "0cm 1cm",
            }}
          >
            <div style={{ margin: "20px auto 5px" }} className="bold">
              สรุปการใช้ใบเสร็จรับเงิน
            </div>
            <div style={{ paddingLeft: "10px" }}>
              <div>1. ใบเสร็จใช้ไป {report.table.total.col_3} ฉบับ</div>
              <div>2. ใบเสร็จยกเลิก {report.table.total.col_4} ฉบับ </div>
              <div>
                3. ใบเสร็จที่ใช้ระหว่างเดือน{" "}
                {report.table.total.col_3 - report.table.total.col_4} ฉบับ (
                {report.table.total.col_3}-{report.table.total.col_4})
              </div>
            </div>
            <div style={{ marginTop: "20px", textAlign: "justify" }}>
              <span className="bold" style={{ paddingRight: "0.5cm" }}>
                หมายเหตุ
              </span>
              ระเบียบการเบิกจ่ายเงินจากคลัง การเก็บรักษาเงิน และการนำเงินส่งคลัง
              พ.ศ.2562 ข้อ 74 ได้กำหนดไว้ว่าใบเสร็จรับเงินเล่มใบ
              สำหรับรับเงินของปีงบประมาณใด ให้ใช้รับเงินภายในปีงบประมาณนั้น
              เมื่อขึ้นปีงบประมาณใหม่ให้ใช้ใบเสร็จรับเงินเล่มใหม่
              ใบเสร็จรับเงินใดยังไม่ได้ใช้ให้คงติดไว้กับเล่ม แต่ให้ปรุ เจาะรู
              หรือประทับตราเลิกใช้
              เพื่อให้เป็นที่สังเกตุมิให้นำมาใช้รับเงินได้อีกต่อไป
            </div>
          </div>
          <Grid container sx={{ marginTop: "2.5cm" }}>
            <Grid item xs={6}></Grid>
            <Grid item xs={6} align="center" sx={{ fontSize: "11pt" }}>
              ลงชื่อ...........................................................
              <div style={{ marginTop: ".2cm" }}>(ผู้มีหน้าที่ตรวจสอบ)</div>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
}
